export const BRANCH = {
    READ: 'Branch.Read',
    WRITE: 'Branch.Write',
};
export const ZIPCODE = {
    READ: 'Zipcode.Read',
    WRITE: 'Zipcode.Write',
};
export const AFTER_HOUR_REFERRAL_RULE = {
    READ: 'AfterHourReferralRule.Read',
    WRITE: 'AfterHourReferralRule.Write',
};
export const SYSTEM = {
    READ: 'System.Read',
    WRITE: 'System.Write',
};
export const CAMPAIGN_ADHOC = {
    READ: 'CampaignAdhoc.Read',
    WRITE: 'CampaignAdhoc.Write',
};
export const CAMPAIGN_ADHOC_TEMPLATE = {
    READ: 'CampaignAdhocTemplate.Read',
    WRITE: 'CampaignAdhocTemplate.Write',
};
export const COMMUNICATION_LOG = {
    READ: 'CommunicationLog.Read',
    WRITE: 'CommunicationLog.Write',
};
export const REPORT = {
    READ: 'Report.Read',
    WRITE: 'Report.Write',
};
export const USER = {
    READ: 'User.Read',
    WRITE: 'User.Write',
};
